window.Sharepoint = {
	
	massEditForm: function(linkedtype, linkedids){

		var options = {
			title	: Loc.g("Modification du partage des éléments sélectionnés"),
			width: MyWindow.small,
			dialogClass: "white",
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"), click : function(){$("#massShareForm").submit();}}
			],
			callback	: function(){Sharepoint.prepareShareForm('recordMassShareForm', 'massShareForm');}
		};
		
		var params = {action:"massShareForm", linkedtype: linkedtype, linkedids:linkedids};
		MyWindow.load("sharepoint", params, options);
		
	},
	
	editForm: function(linkedtype, linkedid){
		var options = {
			title	: Loc.g("Modification du partage"),
			width : MyWindow.small,
			dialogClass: "white",
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"), click : function(){$("#shareForm").submit();}}
			],
			callback : function(){Sharepoint.prepareShareForm();}
		};
		
		var params = {action:"shareForm", linkedtype: linkedtype, linkedid:linkedid};
		MyWindow.load("sharepoint", params, options);
	},
			
		
	prepareShareForm: function(action, formId){
		
		action = (action == undefined) ? 'recordShareForm' : action;
		formId = (formId == undefined) ? "shareForm" : formId;
		
		MyFacture.customForm();
		
		var options = {
				success:function(data){
					var formIsOk = MyForm.processJson(data, "groupForm");
					if(formIsOk){
						Utils.reload();
					}
		}, dataType:"json"};
	
		MyForm.prepare(formId, "sharepoint&"+$.param({action:action}), options, true);
		
	}
	
};
